import Text from '@zenbusiness/common-components/Text';

import Box from '@mui/material/Box';
import IconButton from '@mui/material/IconButton';

import superstyled from '#client/pages/EducationStudio/utils/superstyled';

export const TitleText = superstyled({
  tag: Text,
  styles: {
    '&.MuiTypography-root': {
      marginLeft: '0.5rem'
    }
  }
});

export const SavedIndicatorBox = superstyled({
  Box,
  styles: ({ theme }) => ({
    color: theme.palette.focus60.main,
    display: 'inline-flex',
    alignItems: 'center',
    marginLeft: '1rem'
  })
});
export const StyledIconButton = superstyled({
  tag: IconButton,
  styles: ({ theme }) => ({
    color: theme.palette.focus90.main,
    padding: '0'
  })
});
